import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// workflows — Workflow definitions per company/module/doctype
// ============================================================================
export const workflows = sqliteTable("core_workflow_workflows", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  module: text("module").notNull(),
  doctype: text("doctype").notNull(),
  name: text("name").notNull(),
  description: text("description"),
  isDefault: integer("is_default").default(0),
  isActive: integer("is_active").default(1),
  version: integer("version").default(1),
  canvasData: text("canvas_data"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
}, (table) => ({
  companyModuleIdx: index("wf_company_module_idx").on(table.companyId, table.module, table.doctype),
}));

// Type exports
export type Workflow = typeof workflows.$inferSelect;
export type NewWorkflow = typeof workflows.$inferInsert;
